import { render, staticRenderFns } from "./app-tutorials.vue?vue&type=template&id=bbfcb926&scoped=true&"
import script from "./app-tutorials.vue?vue&type=script&lang=js&"
export * from "./app-tutorials.vue?vue&type=script&lang=js&"
import style0 from "./app-tutorials.vue?vue&type=style&index=0&id=bbfcb926&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfcb926",
  null
  
)

export default component.exports